module.exports = __webpack_public_path__ + "img/Back.66b70ab.svg";